import ReactDOM from 'react-dom/client'
import './index.css'

import { RouterProvider } from 'react-router-dom'

import * as Sentry from '@sentry/react'
import { ErrorEvent, EventHint } from '@sentry/types'
import _ from 'lodash'
import { userClient } from './api/auth'
import { router } from './Router'

Sentry.init({
  dsn: 'https://196970a16639b225d4ddf281a0557cf1@o4505911624925184.ingest.us.sentry.io/4508243939360768',
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  environment: process.env.NODE_ENV === 'production' ? 'production' : 'development',
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  // tracePropagationTargets: ['localhost', /^https:\/\/yourserver\.io\/api/],
  tracePropagationTargets: [
    'localhost',
    /^https:\/\/shop\.aboutfishing\.kr\//,
    /^https:\/\/shop-test\.aboutfishing\.kr\//,
    /^https:\/\/dev-shop\.aboutfishing\.kr\//,
  ],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  // ignoreErrors
  beforeSend(event: ErrorEvent, hint: EventHint) {
    // 401 에러를 필터링하고, 요청 URL이 https://shop-api.e-ncp.com/ 인지 확인하고, headers 에 accessToken 키가 있는지 확인
    let hasAccessToken = false
    userClient.interceptors.request.use(
      async (config) => {
        const isShopByApi = config.baseURL === 'https://shop-api.e-ncp.com'
        if (isShopByApi && _.has(config.headers, 'accessToken')) hasAccessToken = true
        return config
      },
      (error) => {
        return Promise.reject(error)
      }
    )
    const exception = hint?.originalException as any
    const response = exception?.response as any
    const isUnauthorized = response?.status === 401
    if (hasAccessToken && isUnauthorized) return null
    return event
  },
})

// 배포 환경에서 React Developer Tools 비활성화 코드
if (process.env.NODE_ENV === 'production') {
  if (typeof window.__REACT_DEVTOOLS_GLOBAL_HOOK__ === 'object') {
    for (const [key, value] of Object.entries(window.__REACT_DEVTOOLS_GLOBAL_HOOK__)) {
      window.__REACT_DEVTOOLS_GLOBAL_HOOK__[key] = typeof value === 'function' ? () => {} : null
    }
  }
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
  <>
    <RouterProvider router={router} />
  </>
)
